module.exports = __webpack_public_path__ + "img/general-statistics.afd24fad.jpg";